const state = {
    contexto: JSON.parse(localStorage.getItem("contexto")) || null,
    contextoPendente: null,
    interceptadores: new Set(),
};

const getters = {
    contexto: (state) => state.contexto,
    contextoPendente: (state) => state.contextoPendente,
};

const actions = {
    setContexto: ({ state, commit }, novoContexto) => {
        if (state.interceptadores.size == 0) {
            commit("SET_CONTEXT", novoContexto);
            commit("CLEAR_PENDING");
        } else {
            commit("REQUEST_CONTEXT_CHANGE", novoContexto);
        }
    },
    confirmarMudancaContexto({ state, commit }) {
        commit("SET_CONTEXT", state.contextoPendente);
        commit("CLEAR_PENDING");
    },
    cancelarMudancaContexto({ commit }) {
        commit("CLEAR_PENDING");
    },
    interceptar({ commit }, id) {
        commit("REGISTER_INTERCEPTOR", id);
    },
    cancelarInterceptacao({ commit }, id) {
        commit("UNREGISTER_INTERCEPTOR", id);
    },
};

const mutations = {
    SET_CONTEXT: (state, contexto) => {
        state.contexto = contexto;

        if (contexto) {
            localStorage.setItem("contexto", JSON.stringify(contexto));
        } else {
            localStorage.removeItem("contexto");
        }
    },
    REQUEST_CONTEXT_CHANGE: (state, contexto) => {
        state.contextoPendente = contexto;
    },
    REGISTER_INTERCEPTOR(state, id) {
        if (!state.interceptadores.has(id)) {
            state.interceptadores.add(id);
        }
    },
    UNREGISTER_INTERCEPTOR(state, id) {
        state.interceptadores.delete(id);
    },
    CLEAR_PENDING(state) {
        state.contextoPendente = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
